// Routes are stored as the constants and exported
export const HOME = "/";
export const BROWSE_FILES = "/browse-files";
export const SIGN_UP = "/signup";
export const SIGN_IN = "/signin";
export const DASHBOARD = "/dashboard"
